import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        exclusive={true}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The account card presents the user with actions and information
            associated with their bank accounts. The account name or nickname
            and the last four digits of the account number tell the user which
            of their accounts they are looking at. The mandatory primary balance
            appears as an amount with a label, and an optional secondary balance
            displays an amount and a label with or without a due date. Use an{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/link/design'}
            >
              icon link
            </Link>{' '}
            to offer contextual help only if the balance label needs further
            explanation.
          </p>

          <p>
            The checkbox account card is an input field used in forms with the
            states and functionality of the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/radio/design'}
            >
              radio
            </Link>{' '}
            component.
          </p>
          <div class="c-notification--inline-warning">
            <div class="c-notification__icon">
              <i class="icon icon--exclamation"></i>
            </div>
            <div class="c-notification__content">
              Using help links in this pattern may pose an accessibility risk,
              so avoid them whenever possible.
            </div>
          </div>
        </Intro>
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Selected"
          text={
            <p>
              The user can select a single account from a list of options that
              is always visible.
            </p>
          }
        >
          <p>This variant's not built yet</p>
        </Showcase>

        <SectionTitle>Error States</SectionTitle>
        <p>
          The card will display various errors when balance information can't be
          recalled.
        </p>
        <Showcase
          site={data.site}
          title="Functional"
          text="Used when some of the information in the account card can't be shown but the associated actions are still functional. Only show errors where the information is missing. The yellow bar will remain yellow in the error state unless using a status bar."
        ></Showcase>
        <Showcase
          site={data.site}
          title="Non-Functional"
          text="When no information can be shown, or the actions on the card are not functional, the error message will appear without a border."
        ></Showcase>

        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Balance labels should stay on a single line of text. Otherwise, follow
          the microcopy guidelines for the{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/design'}
          >
            link
          </Link>{' '}
          and{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/design'}
          >
            label
          </Link>{' '}
          components.
        </p>
      </Layout>
    </>
  )
}
